//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { AUTH_LOGOUT } from "../../store/actions/auth.js";
export default {
  name: "HeaderComponent",
  data() {
    return {
      username: localStorage.username
    };
  },
  methods: {
    toggle() {
      this.$store.dispatch("sidebar/toggle");
    },
    logout() {
      if (localStorage.getItem("user_data")) {
        this.$store.dispatch("sidebar/setMenu", []);
      }
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    }
  }
};
